import React, { createContext, useContext, useState, useCallback } from 'react';
import {
  fetchAllWorkSessions,
  fetchWorkSessionsByBusiness,
  fetchWorkSessionById,
  createWorkSession,
  updateWorkSession,
  deleteWorkSession,
  fetchWorkSessionsByStaff
} from '../lib/apiClientWorkSession';

const WorkSessionsContext = createContext();

export const useWorkSessionsContext = () => useContext(WorkSessionsContext);

export const WorkSessionsProvider = ({ children }) => {
  const [workSessions, setWorkSessions] = useState([]);

  const fetchAllWorkSessionsData = useCallback(async () => {
    try {
      const data = await fetchAllWorkSessions();
      setWorkSessions(data);
    } catch (error) {
    }
  }, []);

  const fetchWorkSessionsByBusinessData = useCallback(async (businessId) => {
    try {
      const data = await fetchWorkSessionsByBusiness(businessId);
      setWorkSessions(data);
    } catch (error) {
    }
  }, []);

  const getWorkSessionById = useCallback(async (id) => {
    try {
      return await fetchWorkSessionById(id);
    } catch (error) {
      throw error;
    }
  }, []);

  const createWorkSessionAndUpdateList = useCallback(async (sessionData) => {
    try {
      await createWorkSession(sessionData);
    } catch (error) {
      throw error;
    }
  }, []);

  const updateWorkSessionAndRefresh = useCallback(async (id, sessionData, businessId = null) => {
    try {
      await updateWorkSession(id, sessionData);
      if (businessId) {
        await fetchWorkSessionsByBusinessData(businessId);
      }
    } catch (error) {
      throw error;
    }
  }, [fetchWorkSessionsByBusinessData]);

  const deleteWorkSessionAndRefresh = useCallback(async (id, businessId = null) => {
    try {
      await deleteWorkSession(id);
      if (businessId) {
        await fetchWorkSessionsByBusinessData(businessId);
      }
    } catch (error) {
      throw error;
    }
  }, [fetchWorkSessionsByBusinessData]);

  const fetchWorkSessionsByStaffData = useCallback(async (staffId) => {
    try {
      const data = await fetchWorkSessionsByStaff(staffId);
      setWorkSessions(data);
    } catch (error) {
    }
  }, []);

  const contextValue = {
    workSessions,
    fetchAllWorkSessionsData,
    fetchWorkSessionsByBusinessData,
    fetchWorkSessionsByStaffData,
    getWorkSessionById,
    createWorkSessionAndUpdateList,
    updateWorkSessionAndRefresh,
    deleteWorkSessionAndRefresh
  };

  return (
    <WorkSessionsContext.Provider value={contextValue}>
      {children}
    </WorkSessionsContext.Provider>
  );
};
